<template>
    <transition  >
    <div class="container-fluid ">
        <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Today's Patient </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Today's Patient List</a></li>
                                
                            </ol>
                        </div>
                        <div class="page-title-right float-right "> 
                            <!-- <button type="button" class="btn btn-success float-right" style="margin-left: 7px;" @click="toggleImportModal">
                                <i class="fas fa-plus"></i> Bulk Add Patient
                            </button>
                            <button type="button" class="btn btn-primary float-right" @click="toggleModal">
                              Add New
                            </button> -->
                        </div>
                    </div>
                </div>
            </div>  
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">   
                            <Datatable 
                                :columns="columns" 
                                :sortKey="tableData.sortKey"  
                                @sort="sortBy" 
                                v-if="!loading">
                                <template #header > 
                                    <div class="tableFilters" style="margin-bottom: 10px;">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="control" style="float: left;">
                                                    <span style="float: left; margin-right: 10px; padding: 7px 0px;">Show </span>
                                                    <div class="select" style="float: left;">
                                                        <select class="form-select" v-model="tableData.length" @change="getTodayPatientList()"> 
                                                            <option value="10" selected="selected">10</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="500">500</option>
                                                            <option :value="pagination.total">All</option>
                                                        </select>
                                                    </div>
                                                    <span style="float: left; margin-left: 10px; padding: 7px 0px;"> Entries</span>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-2">
                                                
                                            </div>
                                            <div class="col-md-4">
                                                <input type="text" class="form-control" style="float: right;" v-model="tableData.search" placeholder="Search..." @input="getTodayPatientList()">
                                            </div>
                                        </div>
                                    </div>   
                                </template> 
                                <template #body >                            
                                    <tbody v-if="patients.length > 0">
                                        <tr class=" " v-for="(item, i) in patients" :key="i">
                                            <td>{{ i + 1 }} </td> 
                                            <td>{{ item.appointment_date}} </td> 
                                            <td>{{ item.appointment_id}} </td> 
                                            <td>{{ item.patient_name}} </td> 
                                            <td>{{ item.patient_phone }} </td>
                                            <td>{{ item.patient_address }}</td>
                                            <td>
                                                <span class="badge bg-primary" v-if="item.status == 2">Present</span>
                                                <span class="badge bg-success" v-if="item.status == 3">Done</span>
                                            </td>
                                            <td>
                                                <div class="action-btns text-center">
                                                    <!-- item-->
                                                    <a href="javascript:void(0);" @click="prescriptionCreate(item)" class="btn btn-sm btn-primary" title="Prescription Create">
                                                        <i class="mdi mdi-file-document-outline"></i>
                                                    </a> 
                                                    <a href="javascript:void(0);" @click="prescriptionView(item)" class="btn btn-sm btn-info" title="Prescription View">
                                                        <i class="mdi mdi-eye-outline"></i>
                                                    </a> 
                                                    <!-- <a href="javascript:void(0);" class="btn btn-sm btn-warning" @click="edit(item.prescription)" title="Edit">
                                                        <i class="mdi mdi-circle-edit-outline"></i>
                                                    </a>
                                                    <a href="javascript:void(0);" class="btn btn-sm btn-danger" @click="deleteItem(item)" title="Delete">
                                                        <i class="mdi mdi-delete-outline"></i>
                                                    </a> -->
                                                    <!-- item-->
                                                </div>  
                                            </td>
                                        </tr>
                                    </tbody> 
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="6"> No Data Available Here!</td>
                                        </tr>
                                    </tbody>
                                </template> 
                                <template #footer>
                                    <Pagination 
                                        :pagination="pagination"  
                                        :language="lang"
                                        @onChangePage="setPage" > 
                                    </Pagination> 
                                </template> 
                            </Datatable>


                            <div class="tab-pane show active" v-if="loading">
                                <div class="row"> 
                                    <div class="col-md-5">  
                                    </div>
                                    <div class=" col-md-2"> 
                                        <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                    </div>
                                    <div class="col-md-5">  
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div> 

            <Modal @close="toggleModal()" :modalActive="modalActive">
                <div id="prescriptionModal" class="modal-content scrollbar-width-thin">
                    <div class="modal-header"> 
                        <h3>Prescription Create</h3>
                        <button @click="toggleModal()" type="button" class="btn btn-sm btn-danger"> <i class="mdi mdi-close-outline"></i></button>
                    </div>
                    <form @submit.prevent="submitForm()" enctype="multipart/form-data" >
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <!-- Patient Info -->
                                    <div class="row mb-3">
                                        <div class="col-md-12">
                                            <input type="hidden" class="form-control" v-model="form.id" id="prescription_id">
                                            <input type="hidden" class="form-control" v-model="form.appointment_id" id="appointment_id">
                                            <input type="hidden" class="form-control" v-model="form.doctor_id" id="doctor_id">
                                            <input type="hidden" class="form-control" v-model="form.patient_id" id="patient_id">
                                            <input type="hidden" class="form-control" v-model="form.prescription_date" id="prescription_date">
                                            <table class="table table-responsive">
                                                <tr>
                                                    <td width="40%"><strong>Name: </strong> {{ prescription.patient ? prescription.patient.name : '' }}</td>
                                                    <td width="15%"><strong>Age: </strong> {{ form.age }}</td>
                                                    <td width="15%"><strong>Wt: </strong> {{ form.weight }}</td>
                                                    <td width="30%" class="text-right"><strong>Date: </strong> {{ form.prescription_date }}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="row mb-3">
                                        <div class="col-md-4">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <label style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); width: 100%; text-align:left; margin-bottom: 20px; background-color: #313A46; padding: 5px 5px; color: #ffffff">Physical Info & Others </label>
                                                </div>
                                            </div>

                                            <div class="row physical_info">
                                                <div class="form-group col-md-6">
                                                    <div class="mb-3">
                                                        <label for="age">Age</label>
                                                        <input type="text" class="form-control border" @keypress="onkeyPress('age')" v-model="form.age" id="age" placeholder="Age"> 
                                                        <div class="invalid-feedback" v-if="errors.age">
                                                            {{errors.age[0]}}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="form-group col-md-6">
                                                    <div class="mb-3">
                                                        <label for="weight">Weight</label>
                                                        <input type="text" class="form-control border" @keypress="onkeyPress('weight')" v-model="form.weight" id="weight" placeholder="Weight"> 
                                                        <div class="invalid-feedback" v-if="errors.weight">
                                                            {{errors.weight[0]}}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="form-group col-md-6">
                                                    <div class="mb-3">
                                                        <label for="blood_pressure">Blood Pressure</label>
                                                        <input type="text" class="form-control border " @keypress="onkeyPress('blood_pressure')" v-model="form.blood_pressure" id="blood_pressure" placeholder="Blood Pressure"> 
                                                        <div class="invalid-feedback" v-if="errors.blood_pressure">
                                                            {{errors.blood_pressure[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <div class="mb-3">
                                                        <label for="pulse_rate">Pulse Rate</label>
                                                        <input type="text" class="form-control border" @keypress="onkeyPress('pulse_rate')" v-model="form.pulse_rate" id="pulse_rate" placeholder="Pulse Rate"> 
                                                        <div class="invalid-feedback" v-if="errors.pulse_rate">
                                                            {{errors.pulse_rate[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <div class="mb-3">
                                                        <label for="temperature">Temperature</label>
                                                        <input type="text" class="form-control border " @keypress="onkeyPress('temperature')" v-model="form.temperature" id="temperature" placeholder="Temperature"> 
                                                        <div class="invalid-feedback" v-if="errors.temperature">
                                                            {{errors.temperature[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <div class="mb-3">
                                                        <label for="diabetic">Diabetic</label>
                                                        <input type="text" class="form-control border " @keypress="onkeyPress('diabetic')" v-model="form.diabetic" id="diabetic" placeholder="Diabetic"> 
                                                        <div class="invalid-feedback" v-if="errors.diabetic">
                                                            {{errors.diabetic[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group col-md-12">
                                                    <div class="mb-3">
                                                        <label for="problem_description">Problem Description</label>
                                                        <textarea class="form-control border " @keypress="onkeyPress('problem_description')" v-model="form.problem_description" id="problem_description" placeholder="Problem Description"> </textarea>
                                                        <div class="invalid-feedback" v-if="errors.problem_description">
                                                            {{errors.problem_description[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <label style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); width: 100%; text-align:left; margin-bottom: 20px;">Diagnosis Test: </label>
                                                </div>
                                            </div>

                                            <div class="row test_info">
                                                <div class="col-md-12">
                                                    <table id="test_table" class="table table-responsive table-centered">
                                                        <tbody v-if="form.test_items.length > 0">
                                                            <tr v-for="(test, i) in form.test_items" :key="i">
                                                                <td width="90%">
                                                                    <div class="form-group"> 
                                                                        <Multiselect
                                                                            class="form-control border test_id"
                                                                            mode="single"
                                                                            v-model="test.id"
                                                                            placeholder="Select Tests"
                                                                            @change="addNewTestRow($event, i), onChangeTests($event, i)"   
                                                                            :searchable="true" 
                                                                            :filter-results="true"
                                                                            :options="tests"
                                                                            :classes="multiclasses"
                                                                            :close-on-select="true" 
                                                                            :min-chars="1"
                                                                            :resolve-on-load="false"
                                                                            :hide-selected="true" 
                                                                            v-if="test.renderOptionComponent"
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td class="text-center">
                                                                    <a href="javascript:void(0);" class="text-danger" style="font-size: 17px;" @click="removeTestRow(i)" v-if="i > 0"><i class="mdi mdi-close"></i></a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <label style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); width: 100%; text-align:left; margin-bottom: 20px;">Advice: </label>
                                                </div>
                                            </div>

                                            <div class="row advice_info">
                                                <div class="form-group col-md-12">
                                                    <div class="mb-3"> 
                                                        <!-- <label for="test_id">Test</label> -->
                                                        <textarea class="form-control border" v-model="form.advice" @keyup="onkeyPress('advice')" id="advice" placeholder="Advice"></textarea> 
                                                        <div class="invalid-feedback" v-if="errors.advice">
                                                            {{errors.advice[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <label style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); width: 100%; text-align:left; margin-bottom: 20px;">Next Visit: </label>
                                                </div>
                                            </div>

                                            <div class="row visit_info">
                                                <div class="form-group col-md-4">
                                                    <div class="mb-3"> 
                                                        <!-- <label for="next_visit">Next Visit</label> -->
                                                        <input type="number" class="form-control border" v-model="form.next_visit" @keyup="onkeyPress('next_visit')" id="next_visit"> 
                                                        <div class="invalid-feedback" v-if="errors.next_visit">
                                                            {{errors.next_visit[0]}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group col-md-8">
                                                    <Multiselect
                                                        class="form-control border visit_type"
                                                        mode="single"
                                                        v-model="form.visit_type"
                                                        placeholder="Select Type"  
                                                        :searchable="true" 
                                                        :filter-results="true"
                                                        :options="visit_types"
                                                        :classes="multiclasses"
                                                        :close-on-select="true" 
                                                        :min-chars="1"
                                                        :resolve-on-load="false"
                                                        :hide-selected="true"
                                                    />
                                                </div>
                                            </div>

                                        </div>

                                        <div class="col-md-8">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <label style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); width: 100%; text-align:left; margin-bottom: 20px; background-color: #313A46; padding: 5px 5px; color: #ffffff">Medicine </label>
                                                </div>
                                                <div class="clasa-md-12">
                                                    <table class="table table-responsive table-bordered table-centered mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th width="5%">SL</th>
                                                                <th width="30%">Medicines</th>
                                                                <!-- <th width="10%">Dosage</th> -->
                                                                <th width="15%">Dose Interval</th>
                                                                <th width="20%">Time</th>
                                                                <th width="15%">Days</th>
                                                                <!-- <th width="15%">Comment</th> -->
                                                                <th width="5%" class="text-center"><i class="mdi mdi-close"></i></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody >
                                                            <tr v-for="(medicine_item, i) in form.medicine_items" :key="i"> 
                                                                <td class="text-center">{{ i + 1 }}</td>
                                                                <td class="text-center">
                                                                    <input type="hidden" v-model="medicine_item.name">
                                                                    <Multiselect
                                                                        class="form-control border product_id"
                                                                        mode="single"
                                                                        v-model="medicine_item.id"
                                                                        placeholder="Medicines"
                                                                        @change="addNewRow($event, i), onChangeMedicine($event, i)"   
                                                                        :searchable="true" 
                                                                        :filter-results="true"
                                                                        :options="medicines"
                                                                        :classes="multiclasses"
                                                                        :close-on-select="true" 
                                                                        :min-chars="1"
                                                                        :resolve-on-load="false"
                                                                        :hide-selected="true" 
                                                                    />
                                                                </td>
                                                                <!-- <td class="text-center">
                                                                    <input type="text" class="form-control" @focus="addNewRow($event, i)" v-model="medicine_item.dosage">
                                                                </td>           -->                                        
                                                                <td class="text-center">
                                                                    <input type="text" class="form-control" @focus="addNewRow($event, i)" v-model="medicine_item.dose_interval">
                                                                </td>    
                                                                <td class="text-center">
                                                                    <input type="text" class="form-control"  @focus="addNewRow($event, i)" v-model="medicine_item.dose_time">
                                                                </td>
                                                                <td class="text-center"> 
                                                                    <input type="text" class="form-control" @focus="addNewRow($event, i)" v-model="medicine_item.dose_duration">
                                                                </td> 
                                                                <!-- <td class="text-center">
                                                                    <textarea class="form-control" @focus="addNewRow($event, i)" v-model="medicine_item.comment"></textarea>
                                                                </td> -->
                                                             
                                                                <td class="text-center">
                                                                    <a href="javascript:void(0)" class="text-danger" style="font-size: 17px" @click="deleteRow(i)" v-if="i != 0"><i class="mdi mdi-close"></i></a>
                                                                </td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div> 
                            </div>
                        </div>
                        <div class="modal-footer"> 
                            <button type="button" class="btn btn-danger" @click="toggleModal()">
                                Close
                            </button> 
                            <button type="submit" class="btn btn-primary " :disabled="disabled">
                                <span v-show="isSubmit">
                                    <i class="fas fa-spinner fa-spin" ></i>
                                </span>{{btn}} 
                            </button> 
                        </div>
                    </form>
                </div>
            </Modal>
            
            <!-- Prescription view Modal -->
            <Modal @close="prescriptionViewModal()" :modalActive="showModal">
                <div class="modal-content scrollbar-width-thin prescription-view-modal">
                    <div class="modal-header"> 
                        <h5 class="">Prescription View</h5>
                        <button @click="prescriptionViewModal" type="button" class="btn btn-danger"><i class="mdi mdi-close"></i></button>
                    </div> 
                    <div class="modal-body" v-if="prescription">  
                        <div class="row">
                            <div class="col-12">
                                <div class="card">
                                    <div id="prescriptionArea" class="card-body prescription">
                                        <!-- Prescription Header-->
                                        <div class="prescription_header">
                                            <div class="row">
                                                <div class="col-md-4 col-xs-4">
                                                    <div class="prescription_logo">
                                                        <img src="/assets/pad_prescriptions/prescription_logo.png" style="max-width: 100%" alt="logo image">
                                                    </div>
                                                </div>
                                                <div class="col-md-8 col-xs-8">
                                                    <div class="prescription_address">
                                                        <div class="first_address">
                                                            <h6>{{ this.prescriptionHospitalName }}</h6>
                                                            <p>{{ this.prescriptionAddress }}</p>
                                                            <p><span>Cell: {{ this.prescriptionPhone }}</span>, <span>Email: {{ this.prescriptionEmail }}</span></p>
                                                            <p><span>Web: {{ this.prescriptionWeb }}</span></p>
                                                        </div>
                                                        <div class="second_address">
                                                            <h6>{{ this.headOfficeAddressTitle }}</h6>
                                                            <p>{{ this.headOfficeAddress }}</p>
                                                            <p><span>Cell: {{ this.headOfficePhone }}</span>, <span>Email: {{ this.headOfficeEmail }}</span></p>
                                                            <p><span>Web: {{ this.headOfficeWeb }}</span></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> <!-- end row-->

                                        <!-- Prescription Body -->
                                        <div class="prescription_body">
                                            <!-- Patient Details -->
                                            <div class="row">
                                                <div class="col-md-12 table-patient-info">
                                                    <table class="table patient_info">
                                                        <tbody>
                                                            <tr>
                                                                <td width="50%">Name: {{ prescription.patient.name }}</td>
                                                                <td width="15%">Age: {{ prescription.age }}</td>
                                                                <td width="15%">Weight: {{ prescription.weight }}</td>
                                                                <td width="20%" style="text-align: right;">Date: {{ prescription.prescription_date }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <!-- Medicines & Test Details -->
                                            <div class="row">
                                                <div class="col-md-5">
                                                    <div class="left-container">
                                                        <div class="test_details">
                                                            <h2 class="rotate_text">Outdoor Prescription</h2>
                                                            <div class="basic_test_info">
                                                                <h5>C/C: </h5>
                                                                <ul>
                                                                    <li>Blood Pressure: <span>{{ (prescription.blood_pressure) ? prescription.blood_pressure : '---' }}</span></li>
                                                                    <li>Pulse Rate: <span>{{ (prescription.pulse_rate) ? prescription.pulse_rate : '---' }}</span></li>
                                                                    <li>Temperature: <span>{{ (prescription.temperature) ? prescription.temperature : '---' }}</span></li>
                                                                    <li>Blood Sugar: <span>{{ (prescription.diabetic) ? prescription.diabetic : '---' }}</span></li>
                                                                    <li>Diagnosis: <span>{{ (prescription.problem_description) ? prescription.problem_description : '---' }}</span></li>
                                                                </ul>
                                                            </div>
                                                            <div class="examines">
                                                                <h5>O/E: </h5>
                                                                <ul v-if="prescription.test_items">
                                                                    <li v-for="(test_item ,index) in prescription.test_items" :key="index">{{ test_item.name }}</li>     
                                                                </ul>
                                                            </div>                                                    
                                                            <div class="advices">
                                                                <h5>Advice: </h5>
                                                                <ul v-if="prescription_advices.length > 0">
                                                                    <li v-for="(advice, i) in prescription_advices" :key="i">{{ (advice) ? advice : '' }}</li>
                                                                </ul>
                                                            </div>
                                                        </div>

                                                        <div class="next_visit">
                                                            <p><span class="visit_days">{{ prescription.next_visit ?? '' }}</span>দিন পর দেখা করবেন।</p>
                                                            <p>পরবর্তী সাক্ষাতের সময় ব্যবস্থাপত্র সঙ্গে আনবেন।</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-7 pl-0">
                                                    <div class="rx_logo">
                                                        <img src="/assets/pad_prescriptions/rx_logo.png" style="max-width: 100%" alt="">
                                                    </div>
                                                    <div class="medicine_details">
                                                        <ul v-if="prescription.medicine_items">
                                                            <li v-for="(medicine_item ,index) in prescription.medicine_items" :key="index">
                                                                <h5>{{ index + 1}}. {{ medicine_item.name }}</h5>
                                                                <p>
                                                                    <span>Dosage: {{ medicine_item.dose_interval }}</span> 
                                                                    <!-- <span style="padding-left: 10px" v-if="medicine_item.cat_name == 'Syrup'"><i>---</i> {{ medicine_item.dosage+ ' spoon' }}</span>
                                                                    <span style="padding-left: 10px" v-else-if="medicine_item.cat_name == 'Tablet'"><i>---</i> {{ medicine_item.dosage+ ' pcs'}}</span>
                                                                    <span style="padding-left: 10px" v-else-if="medicine_item.cat_name == 'Capsul'"><i>---</i> {{ medicine_item.dosage+ ' pcs'}}</span> -->
                                                                    <span style="padding-left: 10px"><i>---</i> {{ medicine_item.dose_time }}</span>
                                                                    <span style="padding-left: 10px" v-if="medicine_item.dose_duration != ''"><i>---</i> {{ medicine_item.dose_duration }}</span>
                                                                </p>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="prescription_footer">
                                            <a href="https://www.ssgbd.com" target="_blank"><img src="/assets/images/ssg-logo.png" alt="SSGBD"></a>
                                            <p>Affiliated to Abdur Rahim Memorial Trust and A subsidary of </p>
                                        </div> 

                                    </div> <!-- end card-body-->
                                </div> <!-- end card-->
                            </div> <!-- end col-->  
                        </div>
                    </div>
                    <div class="modal-footer"> 
                        <button type="button" class="btn btn-danger" @click="prescriptionViewModal()">
                            Close
                        </button> 
                        <button type="button" class="btn btn-primary" @click="printPrescription()">
                            Print
                        </button> 
                    </div>
                </div>
            </Modal>

        </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "../../helper/Modal";
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { ref, onMounted, reactive } from "vue";
import Form from 'vform'
import axios from 'axios';
export default {
    name: 'Customer',
    components: {
        Modal,
        Datatable,
        Pagination,
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            loading: true,
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            errors: {},
            imagePreview: '',
            btn:'Create',
            items: [],
            patients: [],
            patient_groups: [],
            test_data: [],
            tests: [],
            medicine_data: [],
            medicines: [],
            companies: [],
            visit_types: [
                {label:'Days', value:'days'},
                {label:'Weeks', value:'weeks'},
                {label:'Months', value:'months'},
                {label:'Years', value:'years'},    
            ],
            appointment: '',
            prescription: '',
            prescription_advices: [],
            form: new Form({
                id: '',
                appointment_id: '',
                doctor_id: '',
                patient_id: '', 
                prescription_date: '', 
                age: '',
                weight: '',
                blood_pressure: '', 
                pulse_rate: '', 
                temperature: '',
                diabetic: '',
                problem_description: '',
                test_items: [{id:'', name:'', renderOptionComponent: true}],
                advice: '',
                next_visit: '',
                visit_type: '',
                medicine_items: [
                    {
                        id: '',
                        name: '',
                        dosage: '',
                        dose_duration: '',
                        dose_interval: '',
                        time: '',
                        comment: '',
                    }
                ],    
                status: 1,

            }),
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },            
            columns: [ 
                {
                    label: 'SL',
                    name: '',  
                    isSearch: false, 
                    isAction: true,         
                    width: '5%'
                },     
                {
                    label: 'Date',
                    name: 'appointment_date',
                    width: '10%'
                },
                {
                    label: 'Appointment ID',
                    name: 'appointment_id',
                    width: '15%'
                },
                {
                    label: 'Name',
                    name: 'patient_name',
                    width: '15%'
                },
                {
                    label: 'Phone',
                    name: 'patient_phone',
                    width: '10%'
                },
                {
                    label: 'Address',
                    name: 'address',
                    width: '10%'
                },
                {
                    label: 'Status',
                    name: 'status',
                    width: '7%'
                },
                {
                    label: 'Actions',            
                    name: '',
                    isSearch: false, 
                    isAction: true,
                    width: '18%',

                }
            ],  
            tableData: {
                draw: 0,
                length: 10,
                search: '',
                column: 2,
                dir: 'asc',
                sortKey: 'appointment_id', 
            }, 
            lang: {
                lengthMenu: this.$props.language.lengthMenu ? this.$props.language.lengthMenu : 'Show_MENU_entries',
                info: this.$props.language.info ? this.$props.language.info : 'Showing_FROM_to_TO_of_TOTAL_entries',
                zeroRecords: this.$props.language.zeroRecords ? this.$props.language.zeroRecords : 'No data available in table.', 
                search: this.$props.language.search ? this.$props.language.search : 'Search'
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
                links:[],
            }

        };
    },
    created() { 
        this.getTodayPatientList();
        this.fetchPatientsGroup(); 
        this.fetchProducts();
        this.fetchTestData();
        // this.fetchCompany()
        // this.fetchDistrict()
    },
    methods: { 
        forceTestRerender(index) {
            // Remove my-component from the DOM
            this.form.test_items[index].renderOptionComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.form.test_items[index].id = '';
                this.form.test_items[index].name = '';
                this.form.test_items[index].renderOptionComponent = true;
            });
        },

        toggleModal: function() {
            this.modalActive = !this.modalActive;   
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
            this.form.reset();  
        },
         
        prescriptionViewModal: function() {  
            this.showModal = !this.showModal;
        },

        print(document_id, style_link) { 

            const options = {
                name: '_blank',
                specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
                styles: [ 
                    this.baseUrlPrintCSS+'/assets/css/bootstrap-print.min.css',
                    style_link
                ],
            };
                
            this.$htmlToPaper(document_id, options);

        },

        fetchCompany() { 
            axios.get(this.apiUrl+'/companies', this.headerjson)
            .then((res) => {
                this.companies = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }); 
        }, 
        fetchPatientsGroup() { 
            axios.get(this.apiUrl+'/customer_groups', this.headerjson)
            .then((res) => {
                this.customer_groups = res.data.data; 
            }) 
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            })
        }, 
         // Products Data
        fetchProducts() {
            axios.get(this.apiUrl+"/products", this.headerjson)
            .then((resp) => {
                this.medicine_data  = resp.data.data;
                this.medicines = [{label: "Select Medicine", value: ""}];
                resp.data.data.map((item) => {
                    // this.medicines.push({label:item.product_name+'('+item.product_code+')', value:item.id});
                    this.medicines.push({label:item.product_name, value:item.id});
                });
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            })
            .finally(() => {
                this.loading = false;
            });
        },

         // Products Data
        fetchTestData() {
            axios.get(this.apiUrl+"/hm/diagnosis_tests", this.headerjson)
            .then((resp) => {
                this.test_data  = resp.data.data;
                resp.data.data.map((item) => {
                    this.tests.push({label:item.name, value:item.id});
                });
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            })
            .finally(() => {
                this.loading = false;
            });
        },

        prescriptionCreate: function(item) {
            this.editMode = true;
            this.btn = "Update";
            
            let formData = new FormData();
            formData.append("appointment_id", item.id);
            axios.post(this.apiUrl+'/hm/prescriptions/get-by-id', formData, this.headers)
            .then(res => {
                console.log("response====", res);
                this.prescription = res.data.data;
                var responseData = res.data.data; // Extracting data from response 
                // Creating a new object to ensure reactivity
                var prescription_data = {
                    ...responseData,
                };
                if(res.status == 200){  
                    this.toggleModal(); 
                    this.form.fill(prescription_data);
                } else {
                    this.$toast.error(res.message);
                }
            }).catch(err => {  
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors;
                }
            }) 
        },

        // New Test Row Add
        addNewTestRow(value, index, change_field="") {
            var item_length = this.form.test_items.length;
            if(index == (item_length - 1)) {

                var exists_data = this.form.test_items.find(({id}) => id == value) ?? '';
                if(exists_data == '') {
                    this.form.test_items.push(
                        {
                            id: '',
                            name: '',
                            renderOptionComponent: true,
                        }
                    );
                }

            }
        },

        onChangeTests(test_id, index) {

            if(test_id != 0) {
                const test = this.test_data.find(({id}) => id == test_id);
                var exists_data = this.form.test_items.find(({id}) => id == test_id) ?? '';
                if(exists_data == '') {
                    this.form.test_items[index].id = test.id;
                    this.form.test_items[index].name = test.name;
                }else{
                    this.forceTestRerender(index);
                    this.$toast.error('Test already added!');
                }
            }

        },
        
        removeTestRow(index) {
            this.form.test_items.splice(index, 1);
        },

        
        // New Medicine Row Add
        addNewRow(value, index, change_field="") {
            var item_length = this.form.medicine_items.length;
            if(index == (item_length - 1)) {

                this.form.medicine_items.push(
                    {
                        id: '',
                        name: '',
                        dosage: '',
                        dose_duration: '',
                        dose_interval: '',
                        time: '',
                        comment: '',
                    }
                );
            }
        },

        deleteRow(index) {
            this.form.medicine_items.splice(index, 1);
        },

        onChangeMedicine(product_id, index) {

            if(product_id != 0) {
                const product = this.medicine_data.find(({id}) => id == product_id);

                this.form.medicine_items[index].id = product.id;
                this.form.medicine_items[index].name = product.product_name;
            }

        },

        prescriptionView: function(item, type='view') {                 
            
            let formData = new FormData();
            if(type == 'submit') {
                var appointment_id = item.appointment_id
            }else {
                appointment_id = item.id
            }

            formData.append("appointment_id", appointment_id);
            axios.post(this.apiUrl+'/hm/prescriptions/get-by-id', formData, this.headers)
            .then(res => {            
                this.showModal = !this.showModal;
                if(res.status == 200){ 
                    this.prescription = res.data.data; 
                    if(res.data.data.advice != 'null' || res.data.data.advice != '') {
                        this.prescription_advices = res.data.data.advice.split(";");
                    }
                    if(type == 'submit') {
                        setTimeout(()=>{ this.printPrescription(); }, 1000);
                    }
                } else {
                    this.$toast.error(res.message);
                }
            }).catch(err => {  
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors;
                }
            })
        },

        printPrescription: function() {
            let printStyleLink = this.baseUrlPrintCSS+'/assets/css/print_prescription.css';
            this.print('prescriptionArea', printStyleLink);
        },

        edit: function(item) { 
            this.btn='Update';
            this.editMode = true;
            this.toggleModal();
            this.form.fill(item);
        },

        submitForm: function(e) {  
            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();              
            formData.append('id', this.form.id);
            formData.append('appointment_id', this.form.appointment_id);
            formData.append('doctor_id', this.form.doctor_id);
            formData.append('patient_id', this.form.patient_id);
            formData.append('prescription_date', this.form.prescription_date);
            formData.append('age', this.form.age ?? NULL);
            formData.append('weight', this.form.weight ?? NULL);
            formData.append('blood_pressure', this.form.blood_pressure ?? NULL);
            formData.append('pulse_rate', this.form.pulse_rate ?? NULL);
            formData.append('temperature', this.form.temperature ?? NULL);
            formData.append('diabetic', this.form.diabetic ?? NULL);
            formData.append('problem_description', this.form.problem_description ?? NULL);
            formData.append('advice', this.form.advice ?? NULL);
            formData.append('next_visit', this.form.next_visit ?? NULL);
            formData.append('visit_type', this.form.visit_type ?? NULL);
            formData.append('medicine_items', JSON.stringify(this.form.medicine_items));
            formData.append('test_items', JSON.stringify(this.form.test_items));

            if(this.editMode){
                formData.append('_method', 'put');
                if(this.imagePreview){
                    // this.form.cimage ? formData.append('cimage', this.form.cimage, this.form.cimage.name) : '';
                } 
                var postEvent = axios.post(this.apiUrl+'/hm/prescriptions/'+this.form.id, formData, this.headers);
            }else{  
                // this.form.cimage ? formData.append('cimage', this.form.cimage, this.form.cimage.name) : '';
                var postEvent = axios.post(this.apiUrl+'/hm/prescriptions', formData, this.headers);
            }           

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.toggleModal();
                    this.getTodayPatientList();
                    setTimeout(()=>{ this.prescriptionView(res.data.data, 'submit'); }, 1000);
                    this.$toast.success(res.data.message); 
                }else{
                    this.$toast.error(res.data.message);
                } 
            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                } 
            });
        }, 

        // onImageChange(e) {
        //     this.form.cimage = e.target.files[0]
        //     let files = e.target.files || e.dataTransfer.files;
        //     if (!files.length)
        //         return;  
            
        //     this.createImage(files[0]);

        // },
        // createImage(file) {
        //     let reader = new FileReader();
        //     let vm = this;
        //     reader.onload = (e) => { 
        //         vm.imagePreview = e.target.result;
        //     };
        //     reader.readAsDataURL(file);
        // },

        validation: function (...fiels){ 
            var obj = new Object(); 
            var validate = false;
            for (var k in fiels){     // Loop through the object  
                for (var j in this.form){  
                    if((j==fiels[k]) && (!this.form[j])) {  
                        obj[fiels[k]] = fiels[k].replace("_", " ")+' field is required';  // Delete obj[key]; 
                        this.errors = {...this.errors, ...obj};
                    }else{
                        validate = false;
                    }
                }              
            }  
            // var obj = new Object();
            // obj[fiels] = fiels.replace("_", " ")+' field is required';  
            // this.errors = {...this.errors, ...obj}; 
        },
        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },
        deleteItem: function(item) {
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this appointment!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/hm/appointments/'+item.id,this.headerjson)
                    .then(res => {
                        if(res.status == 200){  
                            this.getTodayPatientList();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message); 
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },

        // For Pagination 
        getTodayPatientList(url = this.apiUrl+'/hm/patients/today') {
            this.tableData.draw++;
            axios.get(url, {params:this.tableData,  headers:this.headerparams})
            .then((response) => {
                let data = response.data.data; 
                if(this.tableData.draw = data.draw) {
                    this.patients = data.data.data;
                    this.configPagination(data.data);
                }
            })
            .catch(errors => {
                this.$toast.error(errors.response.data.message);
            })
            .finally((fres) => {
                // this.loading = false;
            });
        },

        configPagination(data){
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total   = data.total ? data.total : 0;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from ? data.from : 0;
            this.pagination.to = data.to ? data.to : 0;  
            this.pagination.links = data.links;
        },

        sortBy(key,sortable) {
            this.tableData.sortKey = key;
            //this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = sortable; ///this.sortOrders[key] === 1 ? 'asc' : 'desc'; 
            this.getTodayPatientList();
        },
        setPage(data){  
            this.getTodayPatientList(data.url); 
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },


    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {}
}
</script>
<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 900px
}

#prescriptionModal.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 1068px;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}


/* Prescription CSS */
#prescriptionArea h1, h2, h3, h4, h5, h6  {
  font-family: Tahoma, "Trebuchet MS", sans-serif !important;
}
#prescriptionArea {
    /* font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important; */
    font-family: Tahoma, "Trebuchet MS", sans-serif !important;
    border: 1px solid #a19b9b;
    padding: 0;
}
.prescription_header {
    background-color: #094FA4;
    padding: 20px;
}
.prescription_address {
    /* padding-right: 7px; */
}

.first_address {
    color: #ffffff;
    text-align: right;
}

.first_address h6 {
    margin-bottom: 0;
    font-weight: 700;
    font-size: 14px;
}
.first_address p {
    margin: 0px;
    font-size: 14px;
}
.second_address {
    color: #ffffff;
    text-align: right;
}
.second_address h6 {
    margin-top: 15px;
    margin-bottom: 0;
    font-weight: 700;
    font-size: 14px;
}
.second_address p { 
    margin: 0px;
    font-size: 14px;
}

.table.patient_info {
    border-top: 1px dashed #222222;
    border-bottom: 1px dashed #222222;
    margin-top: 10px;
    margin-bottom: 0;
    padding: 15px;
    color: #000000;
    background-color: #D6D6D6;
}
.table.patient_info tr td { 
    border: none;
    padding: 10px 15px;
    font-size: 15px;
    font-weight: 400;
}
.left-container {
    padding: 30px 15px 15px 15px;
    background-color: #F0F9FE;
}
.test_details {
    position: relative;
    padding: 20px;
    min-height: 750px; /* Adjust the height as needed */
}

.rotate_text {
    position: absolute;
    left: 20px;
    bottom: 22%;
    transform: translateY(-50%) rotate(-90deg);
    -webkit-transform: translateY(-50%) rotate(-90deg);
    -moz-transform: translateY(-50%) rotate(-90deg);
    -o-transform: translateY(-50%) rotate(-90deg);
    transform-origin: left center; /* Adjusted origin */
    text-align: center;
    text-transform: uppercase;
    font-weight: 300;
    color: #A3ACB1;
    opacity: 0.7;
    white-space: nowrap;
}

.basic_test_info {
    min-height: 200px;
    padding-left: 35px;
}

.examines {
    min-height: 200px;
    padding-left: 35px;
}

.advices {
    min-height: 250px;
    padding-left: 35px;
}

.basic_test_info h5, .advices h5, .examines h5 {
    font-weight: 400;
}

.basic_test_info ul li, .advices ul li, .examines ul li {
    font-size: 14px;
}

.next_visit {
    min-height: 100px;
}

.next_visit p {
    padding: 10px;
    color:#ff0000;
    border: 1px solid #222222;
    border-radius: 50px;
    text-align: right;
    font-size: 14px;
    font-weight: 500;
}

.next_visit p:first-child {
    margin-left: 30px;
}

.next_visit p span.visit_days {
    position: relative;
    display: inline-block;
    width: 20%;
    margin-right: 20px;
}

.next_visit p span.visit_days:before {
    content: "";
    position: absolute;
    width: 140%;
    height: 1px;
    bottom: 0;
    left: 0px;
    border-bottom: 2px dotted #ff0000;
}

.pl-0 {
    padding-left: 0 !important;
}
.rx_logo {
    padding-left: -7px;
    padding-top: 10px;
}

.rx_logo img {
    height: 45px;
}

.medicine_details {
    padding-top: 20px;
    padding-left: 20px;
}

.medicine_details ul {
    list-style: none;
}

.medicine_details ul li h5{
    font-weight: 400;
}

.medicine_details ul li p{
    padding-left: 20px;
    font-size: 14px;
}

.prescription_footer {
    background-color: #ff0000;
    text-align: right;
    padding: 0px 40px;
    overflow: hidden;
}

.prescription_footer p {
    margin: 0;
    padding: 10px 5px 10px 0;
    float: right;
    color: #ffffff;
}

.prescription_footer a{
    float: right;
}

</style>